import { Component, Input, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Unit } from 'app/entities/unit';
import { Subject } from 'rxjs';
import { openCatalogFormDialog } from '../catalog-form-dialog/catalog-form-dialog.component';

// Botão de cadastro/edição: abre o formulário em diálogo (antes era um mat-menu).
@Component({
  selector: 'app-card-drop-down-unit-create',
  templateUrl: './card-drop-down-unit-create.component.html',
})
export class CardDropDownUnitCreateComponent {

  @Input() appearance: string = 'standard';
  @Input() unit: Unit | null = null;
  @Output() onCreated = new Subject<Unit>();
  @Output() onUpdated = new Subject<Unit>();
  @Input() responsiveBtn = false;
  // Só ícone (ex.: criar dentro de um select): recebe aria-label e tooltip
  @Input() iconOnly = false;
  readonly label = 'Nova unidade';

  constructor(private _dialog: MatDialog) { }

  onClick(event: Event) {
    // Item de menu (Editar): deixa o menu da linha fechar. Nos demais casos (ex.: dentro
    // da busca de um select) o clique não pode chegar à opção do select.
    if (this.appearance !== 'mat-menu-item') {
      event.stopPropagation();
    }
    this.open();
  }

  open() {
    openCatalogFormDialog<Unit>(this._dialog, { kind: 'unit', entity: this.unit })
      .subscribe((result) => {
        if (result?.action === 'created') {
          this.onCreated.next(result.value);
        } else if (result?.action === 'updated') {
          this.onUpdated.next(result.value);
        }
      });
  }

}
